import React, { FC } from "react";
import { DateTimeISO } from "shared-ts-types";
import { DateTimePicker } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";
import { _throw } from "shared-ts-utils-core";
import { useMergeSx } from "./useMergeSx";
import { PropertyEditBaseProps } from "./PropertyEditBaseProps";
import {usePropertyEditBase} from "./usePropertyEditBase";

export interface PropertyEditDateTimeProps extends PropertyEditBaseProps {
  value: DateTimeISO;
  disableFuture?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const PropertyEditDateTime: FC<PropertyEditDateTimeProps> = (props) => {
  const { removable, handleRemove } = usePropertyEditBase(props);
  const sx = useMergeSx(
    {
      width: props.fullWidth ? "100%" : "25ch",
    },
    props.sx,
    [props.sx, props.fullWidth]
  );

  const value = DateTime.fromISO(props.value);

  const handleChange = (value: DateTime | null) => {
    props.onChange(
      value != null ? value.toISO() : null,
      props.name ?? _throw(new Error("name cannot be null"))
    );
  };

  return (
    <DateTimePicker
      label={props.label}
      value={value}
      disableFuture={props.disableFuture}
      onChange={handleChange}
      inputRef={props.inputRef}
      sx={sx}
      slotProps={{
        textField: {
          size: props.size,
          fullWidth: props.fullWidth,
          onBlur: props.onBlur,
        },
      }}
    />
  );
};
